import React from "react";
import { Box, Typography } from "@mui/material";
import { MdLocalPostOffice, MdLocationOn } from "react-icons/md";
import { RiWhatsappFill } from "react-icons/ri";
import { colors, borderRadiusPx } from "../../../../theme";

const FooterContact = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Section Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 4,
            height: 16,
            borderRadius: borderRadiusPx.xs,
            backgroundColor: colors.home.brandRed,
          }}
        />
        <Typography
          sx={{
            fontSize: "0.95rem",
            fontWeight: 700,
            color: colors.neutral.white,
            letterSpacing: "0.02em",
            textTransform: "uppercase",
          }}
        >
          Contact & Support
        </Typography>
      </Box>

      {/* Contact Cards List */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {/* WhatsApp */}
        <Box
          component="a"
          href="https://wa.me/67575647642"
          target="_blank"
          rel="noreferrer noopener"
          className="autobet-footer-contact-item interactive"
          sx={{
            p: 1.25,
            borderRadius: borderRadiusPx.md,
            backgroundColor: colors.alpha.white[5],
            border: `1px solid ${colors.sidebar.border}`,
            color: colors.neutral.white,
            "&:hover": {
              backgroundColor: colors.alpha.white[12],
              borderColor: colors.emerald[500],
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: borderRadiusPx.sm,
              backgroundColor: colors.emerald[50],
              color: colors.emerald[600],
              flexShrink: 0,
            }}
          >
            <RiWhatsappFill size={18} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.75rem", color: colors.slate[400], lineHeight: 1.2 }}>
              WhatsApp Hotline
            </Typography>
            <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: colors.neutral.white, mt: 0.25 }}>
              +675 75647642
            </Typography>
          </Box>
        </Box>

        {/* Email */}
        <Box
          component="a"
          href="mailto:info@autobetlottery.com"
          target="_blank"
          rel="noreferrer noopener"
          className="autobet-footer-contact-item interactive"
          sx={{
            p: 1.25,
            borderRadius: borderRadiusPx.md,
            backgroundColor: colors.alpha.white[5],
            border: `1px solid ${colors.sidebar.border}`,
            color: colors.neutral.white,
            "&:hover": {
              backgroundColor: colors.alpha.white[12],
              borderColor: colors.blue[400],
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: borderRadiusPx.sm,
              backgroundColor: colors.blue[50],
              color: colors.primary.main,
              flexShrink: 0,
            }}
          >
            <MdLocalPostOffice size={18} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.75rem", color: colors.slate[400], lineHeight: 1.2 }}>
              Official Inquiries
            </Typography>
            <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: colors.neutral.white, mt: 0.25, wordBreak: "break-all" }}>
              info@autobetlottery.com
            </Typography>
          </Box>
        </Box>

        {/* Location / Address */}
        <Box
          className="autobet-footer-contact-item"
          sx={{
            p: 1.25,
            borderRadius: borderRadiusPx.md,
            backgroundColor: colors.alpha.white[5],
            border: `1px solid ${colors.sidebar.border}`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: borderRadiusPx.sm,
              backgroundColor: colors.red[50],
              color: colors.red[600],
              flexShrink: 0,
            }}
          >
            <MdLocationOn size={18} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.75rem", color: colors.slate[400], lineHeight: 1.2 }}>
              Registered Office
            </Typography>
            <Typography sx={{ fontSize: "0.825rem", fontWeight: 500, color: colors.slate[200], mt: 0.25, lineHeight: 1.45 }}>
              Barawagi - Kerowagi District, Chimbu Province, Papua New Guinea
            </Typography>
          </Box>
        </Box>
      </Box>

      
    </Box>
  );
};

export default FooterContact;
